/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { PageLink, PageTitle, PageToolbar } from "../../components/layout/core";
import { useNavigate } from "react-router-dom";
import { URL_TEACHER_MAIN_NEW_ABOUT } from "app/mock/page_urls";
import { Empty } from "app/components/common";
import { useQuery } from "react-query";
import { getTeacherAppeal } from "app/api/_requests";
import Components from "app/components";
import { KTIcon } from "_metronic/helpers";

const Dashboard: FC = () => {
  const navigate = useNavigate();
  const { data: teacherAppeal, isSuccess } = useQuery(
    "teacher_appeal",
    getTeacherAppeal
  );

  const dashboardBreadCrumbs: Array<PageLink> = [
    {
      title: "Mening arizam",
      path: "",
      isSeparator: false,
      isActive: false,
    },
  ];
  const dashboardToolbars: Array<PageToolbar> = [
    {
      title: "Ariza yuborish",
      icon: "notepad-edit",
      isActive: true,
      additional: {
        onClick: () => navigate(URL_TEACHER_MAIN_NEW_ABOUT),
      },
    },
  ];

  const header = [
    { label: "№" },
    { label: "Turi" },
    { label: "Nomi" },
    { label: "Fan" },
    { label: "Ball" },
    { label: "O'quv yili" },
    { label: "Status" },
    { label: "Kerakli" },
  ];

  const bodyKey = [
    "id",
    "method.name",
    "name",
    "science.name",
    "ball",
    "created_at",
    "status",
  ];

  return (
    <>
      <PageTitle
        breadcrumbs={dashboardBreadCrumbs}
        toolbar={dashboardToolbars}
        description={"Ariza yuborish va uni ko’rish"}
      />
      {/* <Empty /> */}
      {isSuccess ? (
        <Components.Table
          header={header}
          forPaginationData={teacherAppeal}
          title="Yuborilgan arizalar"
          body={teacherAppeal?.results.map((d) => ({
            ...d,
            actions: (
              <div className="d-flex flex-row gap-2">
                <a href="#" className="btn btn-icon btn-primary">
                  <KTIcon iconName="file-down" className="fs-1"/>
                </a>
                <a href="#" className="btn btn-icon btn-secondary">
                  <KTIcon iconName="eye" className="fs-1"/>
                </a>
              </div>
            ),
          }))}
          bodyKey={[...bodyKey, "actions"]}
        />
      ) : (
        ""
      )}
    </>
  );
};

export { Dashboard };
